import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const HorizontalFilters: LoadableType<{}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-HorizontalFilterPane" */
				'./HorizontalFilters.tsx'
			)
		).HorizontalFilters,
});
